module.exports = __webpack_public_path__ + "img/explore-poster.2f679743.png";